import React, { useState, useEffect } from 'react';
import { getProductsByInventory } from '../../services/productsServices';
import logo1 from '../../images/logo1.PNG';
import '../../styles/ProductCardInventory.css';
export default function InventarioProducts({ FIInventario }) {
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedProductId, setExpandedProductId] = useState(null);
  const [filtroMarca, setFiltroMarca] = useState('');
  const [filtroModelo, setFiltroModelo] = useState('');
  const [filtroCantidad, setFiltroCantidad] = useState('');

  useEffect(() => {
    setProductos([]);
    setError(null);
    setLoading(true);

    const fetchProductos = async () => {
      if (!FIInventario) {
        setLoading(false);
        return;
      }
      try {
        const data = await getProductsByInventory(FIInventario);
        console.log(`Productos recibidos para inventario ${FIInventario}:`, data);
        setProductos(data);
      } catch (err) {
        console.error("Error al obtener productos:", err);
        setError("No se pudieron cargar los productos.");
      } finally {
        setLoading(false);
      }
    };

    fetchProductos();
  }, [FIInventario]);

  const toggleExpand = (id) => {
    setExpandedProductId(prevId => (prevId === id ? null : id));
  };

  const limpiarFiltros = () => {
    setFiltroMarca('');
    setFiltroModelo('');
    setFiltroCantidad('');
  };

  // Filtrado en front-end
  const productosFiltrados = productos.filter(p =>
    (!filtroMarca || (p.FCMarca || '').toLowerCase().includes(filtroMarca.toLowerCase())) &&
    (!filtroModelo || p.FCNombre.toLowerCase().includes(filtroModelo.toLowerCase())) &&
    (!filtroCantidad || String(p.FNCantidad) === filtroCantidad)
  );

  if (loading) return <p>Cargando productos...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div className="info-box">
      <h2>🧾 Productos del Inventario</h2>

      <div className="filtros-ventas" style={{ marginBottom: '20px' }}>
        <input
          type="text"
          placeholder="Buscar marca..."
          value={filtroMarca}
          onChange={(e) => setFiltroMarca(e.target.value)}
          className="input-filtro"
        />
        <input
          type="text"
          placeholder="Buscar modelo..."
          value={filtroModelo}
          onChange={(e) => setFiltroModelo(e.target.value)}
          className="input-filtro"
        />
        <input
          type="number"
          placeholder="Cantidad exacta"
          value={filtroCantidad}
          onChange={(e) => setFiltroCantidad(e.target.value)}
          className="input-filtro"
        />
        <button className="boton-limpiar-filtros" onClick={limpiarFiltros}>
          Limpiar filtros
        </button>
      </div>

      {productosFiltrados.length === 0 ? (
        <p>No hay productos registrados.</p>
      ) : (
        <div className="product-list">
          {productosFiltrados.map((product) => {
            // Borde según cantidad
            const bordeCantidad =
              product.FNCantidad === 0
                ? 'solid 2px red'
                : product.FNCantidad === 2
                ? 'solid 2px orange'
                : 'none';

            const isFlipped = expandedProductId === product.FIProducto;

            return (
              <div
                key={product.FIProducto}
                className={`flip-card ${isFlipped ? 'flipped' : ''}`}
                style={{ border: bordeCantidad }}
              >
                <div className="flip-card-inner">
                  {/* --- CARA ADELANTERA --- */}
                  <div className="flip-card-front">
                    <img
                      src={product.image || logo1}
                      alt={product.FCNombre}
                      className="product-image"
                    />
                    <div className="product-details">
                      <p><strong>ID:</strong> {product.FIProducto}</p>
                      <p><strong>Marca:</strong> {product.FCMarca || '–'}</p>
                      <p><strong>Modelo:</strong> {product.FCNombre}</p>
                    </div>
                    <div className="button-container">
                      <button
                        className="product-button"
                        onClick={() => toggleExpand(product.FIProducto)}
                      >
                        Mostrar más
                      </button>
                    </div>
                  </div>

                  {/* --- CARA TRASERA --- */}
                  <div className="flip-card-back">
                    <p><strong>Precio compra:</strong> ${product.FNPrecioCompra}</p>
                    <p><strong>Precio venta:</strong> ${product.FNPrecioVenta}</p>
                    <p><strong>Disponibilidad:</strong> {product.FNCantidad}</p>
                    <p>
                      <strong>Fecha de compra:</strong>{' '}
                      {product.FDFechaCompra
                        ? new Date(product.FDFechaCompra).toLocaleDateString()
                        : 'N/A'}
                    </p>
                    <p>
                      <strong>Fecha de registro:</strong>{' '}
                      {product.FDFechaRegistro
                        ? new Date(product.FDFechaRegistro).toLocaleDateString()
                        : 'N/A'}
                    </p>
                    <p><strong>Visible en web:</strong> {product.FIEstatus ? 'Sí' : 'No'}</p>
                    <div className="button-container-back">
                      <button
                        className="product-button-back"
                        onClick={() => toggleExpand(product.FIProducto)}
                      >
                        Ocultar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}